export const i18nData = {
  messages: {
    ui: {
      blockTunes: {
        toggler: {
          'Click to tune': 'クリックで調整',
          'or drag to move': 'またはドラッグで移動',
        },
      },
      inlineToolbar: {
        converter: {
          'Convert to': '変換',
        },
      },
      toolbar: {
        toolbox: {
          Add: '追加',
        },
      },
      popover: {
        Filter: 'フィルター',
        'Nothing found': '該当なし',
        'Convert to': '変換',
      },
    },
    toolNames: {
      Text: 'テキスト',
      Heading: '見出し',
      'Unordered List': 'リスト',
      'Ordered List': '番号リスト',
      Link: 'リンク',
      Bold: '太字',
      Italic: '斜体',
      Underline: '下線',
      Image: '画像',
    },
    tools: {
      link: {
        'Add a link': 'リンクを追加',
      },
      header: {
        'Heading 2': '中見出し',
        'Heading 3': '小見出し',
      },
      list: {
        Unordered: 'リスト',
        Ordered: '番号リスト',
        'Start with': '開始番号',
      },
      image: {
        Caption: 'キャプション',
        'Select an Image': '画像を選択',
      },
      convertTo: {
        'Convert to': '変換',
      },
    },
    blockTunes: {
      delete: {
        Delete: '削除',
        'Click to delete': 'クリックで削除',
      },
      moveUp: {
        'Move up': '上へ移動',
      },
      moveDown: {
        'Move down': '下へ移動',
      },
    },
  },
}
